import React from 'react';
import { render } from 'react-dom';
import DeviceRegister from './devices/DeviceRegister';

const mountNode = document.getElementById('mountnode');

if (mountNode) {
    // Render the application
    render(
        <DeviceRegister />,
        mountNode
    );
}
